import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchDocuments, createDocument, updateDocument, deleteDocument, fetchDocumentFile  } from "../api/administrationService";

export const useDocuments = () => {
  const queryClient = useQueryClient();

  // ✅ Consulta optimizada para obtener los documentos
  const {
    data: documents = [], // Previene `undefined` al hacer `.map()`
    error,
    isLoading,
  } = useQuery({
    queryKey: ["documents"],
    queryFn: fetchDocuments,
    staleTime: 1000 * 60 * 5, // Cachea los datos por 5 minutos
    refetchOnWindowFocus: false, // Evita re-fetch cuando se cambia de ventana
    refetchOnMount: false, // No re-fetch al montar el componente si ya está en caché
    refetchOnReconnect: false, // Evita re-fetch al reconectar a la red
  });

  // ✅ Roles reutilizable para invalidar la caché después de cada mutación
  const invalidateDocumentsCache = () => {
    queryClient.invalidateQueries({ queryKey: ["documents"] });
  };

  // ✅ Mutación para crear un documento
  const createMutation = useMutation({
    mutationFn: createDocument,
    onSuccess: invalidateDocumentsCache,
  });

  // ✅ Mutación para actualizar un documento
  const updateMutation = useMutation({
    mutationFn: ({ id, data }) => updateDocument(id, data),
    onSuccess: invalidateDocumentsCache,
  });

  // ✅ Mutación para eliminar un documento
  const deleteMutation = useMutation({
    mutationFn: deleteDocument,
    onSuccess: invalidateDocumentsCache,
  });  

  return {
    documents, // Siempre un array seguro
    error,
    isLoading,
    createMutation,
    updateMutation,
    deleteMutation,
  };
};

export const useDocumentFile = (filePath) => {
  return useQuery({
    queryKey: ["documentFile", filePath], // Se cachea por archivo
    queryFn: () => fetchDocumentFile(filePath),
    enabled: !!filePath, // Solo ejecuta la consulta si hay un `filePath`
  });
};
